/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KostenstelleDto } from '../../models/kostenstelle-dto';

export interface GetKostenstellen$Plain$Params {
}

export function getKostenstellen$Plain(http: HttpClient, rootUrl: string, params?: GetKostenstellen$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KostenstelleDto>>> {
  const rb = new RequestBuilder(rootUrl, getKostenstellen$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<KostenstelleDto>>;
    })
  );
}

getKostenstellen$Plain.PATH = '/v1/kostenstellen';
